// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.forgot-password-form[data-v-f1a68740] {\n    min-height: 100vh;\n    width: 100%;\n    padding-top: 52px;\n    background: #f4f6f9;\n}\n", ""]);
// Exports
module.exports = exports;
